import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { EntityDocument } from '../../entity-document-tree/entity-document.model';
import * as documentActions from '../../entity-document-tree/state/document.action';
import * as fromDocument from '../../entity-document-tree/state/document.reducer';
import { DocumentState } from '../../entity-document-tree/state/document.state';
import { ActivatedRoute } from '@angular/router';
import { text } from '@fortawesome/fontawesome-svg-core';
import { NGOTreeviewItem } from 'src/app/models/ngo-treeview-item.model';
import Utilities from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-entity-document-tree-list',
  templateUrl: './entity-document-tree-list.component.html',
  styleUrls: ['./entity-document-tree-list.component.scss']
})
export class EntityDocumentTreeListComponent implements OnInit {

  countryName: string = '';

  items: NGOTreeviewItem[] = [];
  loaded$: Observable<boolean>;
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 99999
  });

  constructor(private store: Store<DocumentState>,
    private route: ActivatedRoute
  ) {
    this.loaded$ = of(false);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.countryName = params.get('countryName') || '';
      if (this.countryName) {
        this.store.dispatch(new documentActions.loadDocuments(this.countryName));
      }
    });

    this.loaded$ = this.store.pipe(select(fromDocument.getEntityDocumentLoaded));

    this.store.pipe(
      select(fromDocument.getEntityDocument),
      filter(documents => documents && documents.entityId !== undefined && documents.entityId > 0),
      map(documents => this.convertToTreeviewItems([documents], false)))
      .subscribe(items => this.items = items);
  }

  private convertToTreeviewItems(documents: EntityDocument[], collapsed: boolean = true): NGOTreeviewItem[] {
    return documents.map(document => {
      const isYearNode = !!document.year;
      const item = new TreeviewItem({
        text: isYearNode ? document.year.toString() : document.displayName,
        value: isYearNode ? `year-${document.year}` : document.entityId,
        collapsed: collapsed,
        checked: false,
      }) as NGOTreeviewItem;

      item.url = isYearNode ? null : document.url;
      item.isYearNode = isYearNode;
      item.collapsed = item.collapsed == undefined ? true : item.collapsed;
      if (!Utilities.isArrayNullOrEmpty(document.entityDocuments)) {
        item.children = this.convertToTreeviewItems(document.entityDocuments);
      }
      item.hasChildren = item.children && item.children.length > 0;
      return item;
    });
  }

  expandNode(item: NGOTreeviewItem) {
    if (item.hasChildren) {
      this.setNodeCollapsed(item);
    }
  }

  setNodeCollapsed(selectedNode: NGOTreeviewItem) {
    var node = this.findTreeViewItemById(selectedNode.value, this.items);
    node.collapsed = !node.collapsed;
  }

  findTreeViewItemById(id, treeViewItems: NGOTreeviewItem[]): NGOTreeviewItem {
    return this.findTreeViewItem("value", id, treeViewItems);
  }

  findTreeViewItem(prop: string, value, treeViewItems: NGOTreeviewItem[]): NGOTreeviewItem {
    for (var i = 0; i < treeViewItems.length; i++) {
      var curItem = treeViewItems[i];
      if (curItem[prop] == value)
        return curItem;
      if (curItem.children && curItem.children.length > 0) {
        var result = this.findTreeViewItem(prop, value, curItem.children);
        if (result != null) return result;
      }
    }
    return null;
  }

}